var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _vm._m(0);
};
var staticRenderFns = [
    function() {
        var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
        return _c('div', {
            staticClass: "page"
        }, [
            _c('img', {
                attrs: {
                    "src": require("@/assets/img/repay/no-order.png"),
                    "alt": ""
                }
            }),
            _c('h3', [
                _vm._v("Nada pendiente")
            ]),
            _c('p', [
                _vm._v("Nuevo límite te está esperando")
            ])
        ]);
    }
];
export { render, staticRenderFns };
